import React, { useEffect, useState } from 'react';
import { Frame } from 'components';
import CareerDevForm from './CareerDevForm';
import CareerDevList from './CareerDevList';
import { useHasActiveSubscription, getUserCareerOppPosts } from 'utils';
import { Redirect } from 'react-router';

export const SubscriberCareerDevCreate = (props) => {
  const { hasActiveSubscription, isLoading } = useHasActiveSubscription(
    props.user?.id,
  );

  if (!isLoading && !hasActiveSubscription) {
    return <Redirect to="/packages" />;
  }
  return (
    <Frame maxWidth="xs" user={props.user}>
      <CareerDevForm {...props} />
    </Frame>
  );
};

export const SubscriberCareerDevEdit = (props) => {
  const [post, setPost] = useState();
  const { hasActiveSubscription, isLoading } = useHasActiveSubscription(
    props.user?.id,
  );

  useEffect(() => {
    if (!props.match.params.id || post) return;
    getUserCareerOppPosts().then((posts) => {
      const foundPost = posts.find((post) => post.id === props.match.params.id);
      if (foundPost) {
        setPost({
          id: foundPost.id,
          ...foundPost,
          startDate: foundPost.startDate?.toDate(),
          endDate: foundPost.endDate?.toDate(),
        });
      } else {
        props.history.push('/career_dev');
      }
    });
  }, [post, props.history, props.match.params.id]);

  if (!isLoading && !hasActiveSubscription) {
    return <Redirect to="/packages" />;
  }

  return (
    <Frame maxWidth="xs" user={props.user}>
      {post && <CareerDevForm defaultValues={post} {...props} />}
    </Frame>
  );
};

export const SubscriberCareerDevList = (props) => {
  const { hasActiveSubscription, isLoading } = useHasActiveSubscription(
    props.user?.id,
  );
  if (!isLoading && !hasActiveSubscription) {
    return <Redirect to="/packages" />;
  }

  return (
    <Frame maxWidth="xs" user={props.user}>
      <CareerDevList {...props} />
    </Frame>
  );
};
